import axios from "axios";

const loginService = axios.create({
    baseURL: process.env.VUE_APP_USER + "/user",
    timeout: 30000,
    withCredentials: true
});

loginService.defaults.headers['Product'] = 'vsp';

loginService.interceptors.request.use(res => {
    res.headers["token"] = JSON.parse(localStorage.getItem("USER")) ? JSON.parse(localStorage.getItem("USER")).token : '';
    res.headers["userId"] = JSON.parse(localStorage.getItem("USER")) ? JSON.parse(localStorage.getItem("USER")).userId : '';
    return res;
})

loginService.interceptors.response.use(
    response => {
        return response.data;
    },

    error => {
        window.$vm.$Message.error(error.response.data.errMsg);
        return Promise.reject(error)
    }
);

export default {
    /**
     *
     * @param {
     * sessionId
     *  loginName
     * loginType
     * productName
     * password
     * verifyCode
     * } params
     *
     */
    Login(params) {
        return loginService.post("/login", params);
    },

    IsLogin(token) {
        return loginService.post(`/islogin?token=${token}`);
    },
    Logout() {
        return loginService.post("/logout");
    }
};